import React from "react";
import "./styles.scss";
import moment from "moment";
import { withRouter } from "react-router-dom/cjs/react-router-dom.min";
import { Flex, Popconfirm } from "antd";
import { Tag } from "..";

const AdminJobsCard = (props) => {
  const onClickCancel = (e) => {
    console.log(e);
  };

  return (
    <>
      <div
        className={`hne-job-category-card-wrapper ${
          props.isSelect ? "active" : ""
        }`}
      >
        {/* <div className="jccw-logo">
          <img src={props.logo} alt="logo" />
        </div> */}

        <div className={"jcw__job-date"}>
          <span className={"tncmw__nd-day"} style={{ marginRight: "10px" }}>
            {moment(props?.closeDate).format("DD")}
          </span>
          <span className={"tncmw__nd-month"}>
            {moment(props?.closeDate).format("MMM")}
          </span>
        </div>

        <div className="jccw-details-wrapper">
          <div className="jccw-title-en">{props.titleEn}</div>
          <div className="jccw-title-si">{props.titleSi}</div>
          <div className="jccw-date">
            Closing Date: {moment(props.closeDate).format("YYYY-MM-DD")}
          </div>
          <div style={{ display: "flex", flexDirection: "row", gap: "5px" }}>
            <div className="jccw-name">{props.name}</div>
            <Tag
              data={{
                isIcon: true,
                tagIcon: "eye",
                tagName: props?.views,
                type: "views_tag",
              }}
            />
          </div>
        </div>
        {props.type === "admin" && (
          <div className="jccw-buttons-wrapper">
            <div className="jccw-view" onClick={props.onClickView}>
              {props.view}
            </div>
            <div className="jccw-edit" onClick={props.onClickEdit}>
              {props.edit}
            </div>
            <div className="jccw-delete">
              <Popconfirm
                placement="topLeft"
                title="Delete the image"
                description="Are you sure to delete this Image?"
                onConfirm={props.onClickRemove}
                onCancel={onClickCancel}
                okText="Yes"
                cancelText="No"
              >
                {props.delete}
                {/* <span className="remove-button"> {GetIconByName("cross")}</span>{" "} */}
              </Popconfirm>
            </div>
          </div>
        )}
      </div>
    </>
  );
};

export default withRouter(AdminJobsCard);
